import React from 'react';
import { IconProps } from './types';

export function ClipOverPaper(props: IconProps) {
  return (
    <svg
      width="29"
      height="38"
      viewBox="0 0 29 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.5"
        y="1"
        width="28"
        height="36"
        fill="white"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M17.4231 14.3846L9.88462 21.9231C9.28985 22.5178 9.28985 23.4821 9.88462 24.0769V24.0769C10.4794 24.6717 11.4437 24.6717 12.0385 24.0769L20.6538 15.4615C21.8434 14.272 21.8434 12.3434 20.6538 11.1538V11.1538C19.4643 9.96431 17.5357 9.96431 16.3462 11.1538L7.73077 19.7692C5.94646 21.5535 5.94647 24.4465 7.73077 26.2308V26.2308C9.51508 28.0151 12.408 28.0151 14.1923 26.2308L21.7308 18.6923"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
